import Vue from "vue";
import * as api from "@/api/bulkedit.api";
import { editCategories } from "@lab/meta/bulkEditing";
import { Listing } from "@lab/types/listings";
import { sortBy } from "lodash";

const state = {
	listings: null,
	category: null,
	option: null,
	value: null
};

const getters = {
	listings: (state): Listing[] => {
		return (
			state.listings ? Object.values(state.listings) : []
		) as Listing[];
	},
	category: (state) => state.category,
	categories: () => sortBy([...editCategories], "name") || [],
	option: () => state.option,
	options: (state) => {
		if (state.category) {
			return state.category.options;
		}
		return [];
	},
	value: () => state.value,
	values: (state) => {
		if (state.option) {
			const { options } = state.option;
			return options
				? Object.entries(options).map(([value, label]) => {
						return {
							value,
							label
						};
				  })
				: [];
		}
		return [];
	}
};

const actions = {
	addListings({ commit }, listings) {
		commit("ADD_LISTINGS", listings);
	},
	updateListing({ commit }, update) {
		commit("UPDATE_LISTING", update);
	},
	updateCategory({ commit }, category) {
		commit("UPDATE_CATEGORY", category);
	},
	updateOption({ commit }, option) {
		commit("UPDATE_OPTION", option);
	},
	updateValue({ commit }, value) {
		commit("UPDATE_VALUE", value);
	},
	async submitUpdates({ getters }, id) {
		const { listings } = getters;

		await api.updateList(
			id, // organisation id
			listings
		);
	},
	updateColumns({ commit, getters }, { value, name }) {
		getters.listings.forEach(({ id }) => {
			const update = {
				value,
				name,
				id
			};

			commit("UPDATE_LISTING", update);
		});
	},
	updateAllColumns({ commit, getters }, { option, name }) {
		const { listings } = getters;

		const listingsToUpdate = listings.filter(
			(listing) => !listing[name].includes(option)
		);

		listingsToUpdate.forEach(({ id }) => {
			const update = {
				value: option,
				name,
				id
			};
			commit("ADD_ITEM_LISTING", update);
		});
	},
	removeAllColumns({ commit, getters }, { option, name }) {
		const { listings } = getters;

		listings.forEach(({ id }) => {
			const update = {
				value: option,
				name,
				id
			};
			commit("REMOVE_ITEM_LISTING", update);
		});
	}
};

const mutations = {
	ADD_LISTINGS(state, listings: Listing[]) {
		const byID = listings.reduce((acc, val) => {
			acc[val.id] = val;
			return acc;
		}, {});
		Vue.set(state, "listings", byID);
	},
	UPDATE_LISTING(state, update) {
		const { id, name, value } = update;

		state.listings[id][name] = value;
	},
	ADD_ITEM_LISTING(state, update) {
		const { id, name, value } = update;
		state.listings[id][name].push(value);
	},
	REMOVE_ITEM_LISTING(state, update) {
		const { id, name, value } = update;
		// filter the array not to included supplied value
		const filtered = state.listings[id][name].filter(
			(item) => item !== value
		);
		// store the item against the listing
		state.listings[id][name] = filtered;
	},
	UPDATE_CATEGORY(state: any, category) {
		state.category = category;
	},
	UPDATE_OPTION(state: any, option) {
		state.option = option;
	},
	UPDATE_VALUE(state: any, value) {
		state.value = value;
	}
};

export default { namespaced: true, state, getters, actions, mutations };
